import { render } from "./ProformaSettingForm.vue?vue&type=template&id=5956a4c8"
import script from "./ProformaSettingForm.vue?vue&type=script&lang=js"
export * from "./ProformaSettingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__